import React from "react";

export const usePassword = () => {
  const [hide, setHide] = React.useState(true);
  const [password, setPassword] = React.useState<any>('');

  return [hide, setHide, password, setPassword];
};
